import { buildService } from './decorated-service';
import {
  StaticContributoryApplication,
  OptionalStaticContributoryApplication,
  ContributoryApplication
} from '../../../core/types/applications/contributory-application';
import {
  // checkAllocationTotals,
  handleSubmissionError,
  purgeEmptyFields,
  removeExtraAddressFields,
  submissionTimeOutErrorCode
} from './util';
import { consumerTypes } from '../utils';

const api = buildService(
  '/new-account-svc/service/v2/account/mutualfund-contributory-ira'
);

const fonasuApi = buildService(
  '/new-account-svc/service/front-office/v2/account/mutualfund-contributory-ira'
);

// TODO [2021-02-01]: register flow with new Retirment Contributory Application State using generics
export const createContributoryApplicationService = (
  args: OptionalStaticContributoryApplication,
  consumerName
): Promise<any> => {
  // TODO [2021-02-01]: register flow with new generic types for account type submissions
  const validated: StaticContributoryApplication = ContributoryApplication.check(
    args
  );
  const submissionPayload = purgeEmptyFields(validated);
  const finalSubmissionPayload = removeExtraAddressFields(submissionPayload);

  const apiEndpoint = consumerName === consumerTypes.FONASU ? fonasuApi : api;

  return apiEndpoint.add(finalSubmissionPayload, {
    submissionTimeOutErrorCode,
    handleServiceResponse: handleSubmissionError
  });
};
